import type { OperationalObligation } from "@io-spoke/contracts/obligations";

type OwnershipOrigin = NonNullable<OperationalObligation["ownershipOrigin"]>;

const ownershipCopy: Record<OwnershipOrigin, { label: string; explanation: string }> = {
  source: {
    label: "Source assignee",
    explanation: "Imported from the connected source. Responsibility in IO Spoke has not been recorded.",
  },
  reviewed: {
    label: "Responsibility recorded",
    explanation: "A reviewer recorded this responsibility in IO Spoke. Membership and acceptance are not verified.",
  },
  unassigned: {
    label: "IO Spoke responsibility",
    explanation: "Choose who is responsible for the next step.",
  },
  unknown: {
    label: "Owner reference",
    explanation: "The origin of this reference is unverified. Record responsibility in IO Spoke.",
  },
};

export function obligationOwnership(obligation: OperationalObligation) {
  const origin = obligation.ownerId ? obligation.ownershipOrigin ?? "unknown" : "unassigned";
  return {
    ...ownershipCopy[origin],
    reference: obligation.ownerId ?? "Not assigned",
    recorded: origin === "reviewed",
  };
}
